// ANCHOR Base
import { Block } from 'baseui/block';
import { LabelLarge } from 'baseui/typography';

// ANCHOR Models
import { useCourseModulePaymentPanelDataHeader } from '@lyon/scoped-models/course-payment/CourseModulePaymentPanelData';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

// ANCHOR Styles
import { BLOCK } from './styles';

export const LyonCourseOutlinePanelHeader = constant(() => {
  const [title, order] = useCourseModulePaymentPanelDataHeader();

  const NUMBER = (order >= 0 && order < 10) ? `0${order}` : order;

  return (
    <Block overrides={BLOCK}>
      <LabelLarge>
        {NUMBER}
      </LabelLarge>
      <LabelLarge>
        {title}
      </LabelLarge>
    </Block>
  );
});
